<!-- 保证金审核Ops-->
 
<template>
  <div class="classification">
    <el-form>
      <div class="header">
        <div class="flex-warp-btn">
          <el-form-item v-if="!expanded" class="search-item">
            <el-input size="small" placeholder="申请ID/商户ID/商户名称/审核人姓名" v-model.trim="formTool.keyWords" clearable
              style="width: 300px;" />
          </el-form-item>
          <span v-else class="flex-warp">
            <el-form-item class="search-item">
              <el-select v-model.trim="formTool.shopTypeCode" clearable style="width: 160px;" size="small"
                placeholder="商户类型">
                <el-option v-for="item in shopTypeCodeOptions" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item class="search-item">
              <el-select v-model="formTool.status" clearable style="width: 160px;" size="small" placeholder="审核状态">
                <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item class="search-item">
              <el-input size="small" placeholder="申请ID" v-model.trim="formTool.bizNo" clearable />
            </el-form-item>
            <el-form-item class="search-item">
              <el-input size="small" placeholder="商户ID" v-model.trim="formTool.shopId" clearable />
            </el-form-item>
            <el-form-item class="search-item">
              <el-input size="small" placeholder="商户名称" v-model.trim="formTool.shopName" clearable />
            </el-form-item>
            <el-form-item class="search-item">
              <el-input size="small" placeholder="审核人姓名" v-model.trim="formTool.approver" clearable />
            </el-form-item>

          </span>
          <div class="flex-warp">
            <el-form-item class="search-item">
              <el-button size="small" @click="reset">重置</el-button>
            </el-form-item>
            <el-form-item class="search-item">
              <el-button type="primary" size="small" @click="getList(1)">
                搜索
              </el-button>
            </el-form-item>
            <el-form-item class="search-item">
              <el-button type="text" size="small" @click="handleExpand()">
                {{ expanded ? "收起" : "展开"
                }}<i :class="{
    'el-icon-arrow-up': expanded,
    'el-icon-arrow-down': !expanded,
    'el-icon--right': true,
  }"></i>
              </el-button>
            </el-form-item>
          </div>

        </div>
      </div>
    </el-form>
    <div class="content">
      <div class="center" style="position: relative">
        <MyTable :table-data="tableData" :index="index" :selection="selection" :page="page" :operation="operation"
          :table-option.sync="tableOption" @page-change="getList" @handleSelectionChange="handleSelectionChange">
          <template slot="menu" slot-scope="scope">
            <el-link :underline="false" type="primary" @click="detailHandle(scope.row, '审核')"
              v-if="scope.row.status == 'submit'" class="btn-list">审核</el-link>
            <el-link :underline="false" type="primary" @click="detailHandle(scope.row, '详情')"
              class="btn-list">详情</el-link>
          </template>

          <template slot="concatName" slot-scope="scope">
            {{ scope.row.concatName }}<br />
            {{ scope.row.concatPhone }}
          </template>
          <template slot="status" slot-scope="scope">
            <span v-if="scope.row.status == 'submit'">
              待审核
            </span>
            <span v-if="scope.row.status == 'pass'">
              审核通过
            </span>
            <span v-if="scope.row.status == 'fail'">
              驳回
            </span>
          </template>
          <template slot="shopTypeCode" slot-scope="scope">
            {{ scope.row.shopTypeCode | filterShopTypeCode }}
          </template>
        </MyTable>
      </div>
      <addDialog ref="add-dialog" @getList="getList" />

    </div>
  </div>
</template>
      
<script>
// const shopTypeOptions = [
//   {
//     value: '1',
//     label: '保证金充值'
//   },
//   {
//     value: '2',
//     label: '订单资金抵押'
//   },
//   {
//     value: '3',
//     label: '服务费超时扣除'
//   }, 
// ]
const statusOptions = [{
  value: 'submit',
  label: '待审核'
},
{
  value: 'fail',
  label: '驳回'
},
{
  value: 'pass',
  label: '审核通过'
},]

const shopTypeCodeOptions = [{
  value: '1',
  label: '诊所'
},
{
  value: '2',
  label: '春播平台'
},
{
  value: '3',
  label: '医药公司'
},
{
  value: '4',
  label: '生产企业'
},]
// CLINIC(1, "诊所"),
// CBPT(2, "春播平台"),
// YYGS(3, "医药公司"),
// SCQY(4, "生产企业");
import MyTable from "@/components/myTable";
import addDialog from "./components/chargeMoney.vue";
import avater from "/public/img/default.png";
import { platformApprove, historyApprovePage } from "@/api/surety";

export default {
  components: { MyTable, addDialog },
  data() {
    return {
      // shopTypeOptions:shopTypeOptions,
      statusOptions: statusOptions,
      activeName: 'first',
      avater: avater,
      formTool: {
      },
      btnType: 'add',
      selectionList: [],
      operation: true,
      selection: false,
      index: true,
      tableData: [],
      tableOption: [
        { label: "申请ID", prop: "bizNo" },
        { label: "商户ID", prop: "shopId" },
        { label: "商户名称", prop: "shopName" },
        { label: "运营人员&联系方式", prop: "concatName", slot: true },
        { label: "商户类型", prop: "shopTypeCode", slot: true },
        { label: "申请金额", prop: "amount",type:'money'},
        { label: "审核状态", prop: "status", slot: true },
        { label: "审核时间", prop: "approveTime" },
        { label: "审核人姓名", prop: "approver" },
        { label: "提交审核时间", prop: "createTime" },
        // { label: "位置描述", prop: "", slot: true },
      ],
      shopTypeCodeOptions: shopTypeCodeOptions,
      page: {
        total: 0,
        current: 1,
        size: 10,
        pageSizes: [10, 20, 30, 50],
      },

      expanded: false,
      dialogShow: false
    };
  },
  computed: {},
  filters: {
    filterPlatName(e) {
      for (let i = 0; i < sourceTypeOptions.length; i++) {
        if (e == sourceTypeOptions[i].value) return sourceTypeOptions[i].label
      }
    },
    filterShopTypeCode(e) {
      for (let i = 0; i < shopTypeCodeOptions.length; i++) {
        if (e == shopTypeCodeOptions[i].value) return shopTypeCodeOptions[i].label
      }
    },
  },
  watch: {},
  created() {
    this.getList();
  },
  mounted() { },
  beforeCreate() { },
  beforeMount() { },
  beforeUpdate() { },
  updated() { },
  beforeDestroy() { },
  destroyed() { },
  activated() { },
  computed: {

  },
  methods: {

    // 页码变化
    handleCurrentChange(e) {
      this.page.current = e
    },
    // 条数变化
    handleSizeChange(e) {
      this.page.size = e
      this.page.current = 1
    },
    handleExpand() {
      this.expanded = !this.expanded;
    },

    detailHandle(row, btnType) {
      if (btnType == '审核') {
        this.$refs['add-dialog'].init(row, 'audit')
      }
      if (btnType == '详情') {
        this.$refs['add-dialog'].init(row, 'detail')
      }
    },

    // 重置查询条件
    reset() {
      this.formTool = {};
      this.getList(1);
    },
    // 搜索
    getList(current) {
      if (current) {
        this.page.current = current;
      }
      const params = {
        ...this.formTool,
        current: this.page.current,
        size: this.page.size
      };

      historyApprovePage(params).then((res) => {
        if (res) {
          this.tableData = res.records;
          this.page.total = res.total;
        } else {
          this.tableData = [];
          this.page.total = 0;
        }
      });
    },
    // 勾选
    handleSelectionChange(val) {
      this.selectionList = val;
    },

  },
};
</script>
<style lang='scss' scoped>
.classification {
  overflow: inherit;
}

.search-item {
  margin-right: 10px;
}

.header {
  margin-top: 20px;
}

.item-wrap {
  margin: 10px 0;
}

.flex-warp {
  display: flex;
  justify-content: flex-start;
}

.flex-warp-btn {
  display: flex;
  justify-content: space-between;
}

.content {

  height: calc(100% - 120px);

  .header {
    width: calc(100% - 12px);
    margin: 0px;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;

    .font {
      font-size: 16px;
      font-family: PingFangSC, PingFangSC-Medium;
      font-weight: 600;
      text-align: left;
      color: #262626;
    }

    .el-form-item {
      margin: 0px 0px 0px 0px !important;
    }
  }

  .center {
    margin-top: 0px;
    padding: 0 0px;
    height: calc(100% - 0px);

    .shangjia {
      position: absolute;
      z-index: 2;
      bottom: -45px;
    }
  }

  .btn-warp {
    display: flex;
    justify-content: space-around;

  }
}

.btn-list {
  margin: 0 10px;
}

::v-deep .el-table {
  height: calc(100% - 120px) !important;
  overflow: auto;
}

.export-btn {
  width: 102px;
  position: absolute;
  top: -50px;
  right: 14px;
}
</style>
      